import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {CsvSubscription} from '../../classes/csv-subscription/csv-subscription';
import {NewsteoSubscription} from '../../classes/newsteo-subscription/newsteo-subscription';

@Injectable({
  providedIn: 'root'
})
export class ProjectSubscriptionService {

  constructor(private http: HttpClient) {
  }

  getSenceiveSubscription(subscriptionId: number) {
    return this.http.get(`settings/senceive-subscription/` + subscriptionId.toString());
  }

  postSenceiveSubscription(senceiveSubscription: any) {
    return this.http.post(`setting/senceive-subscription`, senceiveSubscription);
  }

  deleteSenceiveSubscription(subscriptionId: number) {
    return this.http.delete(`setting/senceive-subscription/` + subscriptionId.toString());
  }

  getCsvSubscription(subscriptionId: number) {
    return this.http.get(`subscriptions/export_subscription/settings/` + subscriptionId.toString());
  }

  postCsvSubscription(csvSubscription: CsvSubscription) {
    return this.http.post(`subscriptions/export_subscription`, csvSubscription);
  }

  deleteCsvSubscription(subscriptionId: number) {
    return this.http.delete(`subscriptions/export_subscription/settings/` + subscriptionId.toString());
  }

  getNewsteoSubscription(subscriptionId: number) {
    return this.http.get(`subscriptions/newsteo_subscription/settings/` + subscriptionId.toString());
  }

  postNewsteoSubscription(newsteoSubscription: NewsteoSubscription) {
    return this.http.post(`subscriptions/newsteo_subscription`, newsteoSubscription);
  }

  deleteNewsteoSubscription(subscriptionId: number) {
    return this.http.delete(`subscriptions/newsteo_subscription/settings/` + subscriptionId.toString());
  }

  postEventdynSubscription(projectId: number) {
    return this.http.post(`subscriptions/eventdyn_subscription`, {projectId});
  }

  deleteEventdynSubscription(subscriptionId: number) {
    return this.http.delete(`subscriptions/eventdyn_subscription/settings/` + subscriptionId.toString());
  }

}
